import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"; // For translations
// import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useDispatch } from "react-redux";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { FaFilePdf } from "react-icons/fa";

const ChecklistFarCitizen = ({ formData, userInfo, lastEmpRole, setCurrentTab, setRemarksData }) => {
  const { t } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const dispatch = useDispatch();
  const defaultValues = {
    ...formData,
    checklist: {
      ...formData?.checklist,
    },
  };

  console.log("fromChecklist", formData);

  const { control, handleSubmit, watch, reset, setValue, register } = useForm({ defaultValues });
  const firstCheckList = formData?.checklist?.firstCheckList;
  const secondCheckList = formData?.checklist?.secondCheckList;
  const reviewChecklist1 = formData?.checklistReview?.firstCheckList;
  const reviewChecklist2 = formData?.checklistReview?.secondCheckList;
  //Documents fetching and structuring below
  const normalizeDocuments = (docs) => {
    if (docs && typeof docs === "object" && !Array.isArray(docs)) {
      return Object.values(docs);
    }
    return docs;
  };
  const documents = normalizeDocuments(formData?.documents) || {};

  let improvedDoc = [];

  documents?.map((appDoc) => {
    improvedDoc.push({ ...appDoc, module: "OBPS" });
  });
  // attaching url to documents below
  const { data: pdfDetails, isLoading: docsLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: improvedDoc?.length > 0 ? true : false,
  });

  let applicationDocs = []; //final ready documnets
  if (pdfDetails?.pdfFiles?.length > 0) {
    pdfDetails?.pdfFiles?.map((pdfAppDoc) => {
      if (pdfAppDoc?.module === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  console.log("applicationDOcs", applicationDocs);
  const proposalDocument = applicationDocs.filter((item) => ["proposalDocument"].includes(item.documentType))?.[0]?.fileStoreId;
  const drawingFile = applicationDocs.filter((item) => ["drawingFile"].includes(item.documentType))?.[0]?.fileStoreId;
  const structuralCertificate = applicationDocs.filter((item) => ["structuralCertificate"].includes(item.documentType))?.[0]?.fileStoreId;
  const fireDepartmentCertificate = applicationDocs.filter((item) => ["fireDepartmentCertificate"].includes(item.documentType))?.[0]?.fileStoreId;
  // const Modal = useModal();
  // const handleInputChange = (name, value) => {
  //   // Save input value to sessionStorage
  //   console.log("name", name, "value", value);

  //   const currentData = JSON.parse(sessionStorage.getItem("checklistReview")) || {};
  //   console.log("currentData", currentData);

  //   currentData[name] = value;
  //   sessionStorage.setItem("checklistReview", JSON.stringify(currentData));
  // };

  useEffect(() => {
    // Check sessionStorage for saved data
    const storedData = sessionStorage.getItem("checklistReview");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      // Populate form fields with stored data
      Object.keys(parsedData).forEach((key) => {
        setValue(key, parsedData[key]);
      });
    }
  }, [setValue]);

  return (
    <div>
      <div
        className="formContainer"
        style={{ marginTop: "18px" }}
        onBlur={(e) => {
          handleInputChange(e.target.name, e.target.value);
        }}
      >
        {/* <div className="formHeaderContainer">
          <h2 className="formHeading">Checklist 1</h2>
        </div> */}
        <Table bordered className="m-0">
          <thead className="table-header">
            <tr>
              <th style={{ minWidth: "fit-content" }}>Field Name</th>
              <th style={{ minWidth: "fit-content" }}>User Input</th>
              <th style={{ minWidth: "fit-content" }}>Officer Verification</th>
              <th style={{ minWidth: "fit-content" }}>Correction</th>
              <th style={{ minWidth: "fit-content" }}>Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>{t("LABEL_SETBACK_POSITION")}</strong>
              </td>
            </tr>
            {["Front", "Rear", "SSB1", "SSB2"].map((position) => (
              <tr key={position}>
                <td>
                  {position}
                  <span className="compulsoryField"> *</span>
                </td>
                <td>{firstCheckList?.setbackPosition?.[position.toLowerCase()] || ""}</td>
                <td>{reviewChecklist1?.setbackPosition?.[position.toLowerCase()]?.verifiedByOfficer}</td>
                <td>{reviewChecklist1?.setbackPosition?.[position.toLowerCase()]?.correction}</td>
                <td>{reviewChecklist1?.setbackPosition?.[position.toLowerCase()]?.remarks}</td>
              </tr>
            ))}
            <tr>
              <td>
                Height of Proposed Building (m)<span className="compulsoryField"> *</span>
              </td>
              <td>{firstCheckList?.buildingHeight || ""}</td>
              <td>{reviewChecklist1?.buildingHeight?.verifiedByOfficer}</td>
              <td>{reviewChecklist1?.buildingHeight?.correction}</td>
              <td>{reviewChecklist1?.buildingHeight?.remarks}</td>
            </tr>

            <tr>
              <td>
                Proposal Document (PDF)<span className="compulsoryField"> *</span>
              </td>
              <td>
                <FaFilePdf
                  color="#a10505"
                  style={{ width: "20px", height: "30px" }}
                  onClick={() => getDocumentByFileStoreId(proposalDocument, setIsPreviewLoading)}
                />
              </td>
              <td>{reviewChecklist1?.proposalDocument?.verifiedByOfficer}</td>
              <td>{reviewChecklist1?.proposalDocument?.correction}</td>
              <td>{reviewChecklist1?.proposalDocument?.remarks}</td>
            </tr>

            <tr>
              <td>
                Drawing File (.dwg)<span className="compulsoryField"> *</span>
              </td>
              <td>
                <FaFilePdf
                  color="#a10505"
                  style={{ width: "20px", height: "30px" }}
                  onClick={() => getDocumentByFileStoreId(drawingFile, setIsPreviewLoading)}
                />
              </td>
              <td>{reviewChecklist1?.drawingFile?.verifiedByOfficer}</td>
              <td>{reviewChecklist1?.drawingFile?.correction}</td>
              <td>{reviewChecklist1?.drawingFile?.remarks}</td>
            </tr>

            <tr>
              <td>
                Structural Safety Certificate Applicable<span className="compulsoryField"> *</span>
              </td>
              <td>{firstCheckList?.structuralSafety || ""}</td>
              <td>{reviewChecklist1?.structuralSafety?.verifiedByOfficer}</td>
              <td>{reviewChecklist1?.structuralSafety?.correction}</td>
              <td>{reviewChecklist1?.structuralSafety?.remarks}</td>
            </tr>

            {firstCheckList?.structuralSafety === "Yes" && (
              <tr>
                <td>
                  Attached Document<span className="compulsoryField"> *</span>
                </td>
                <td>
                  <FaFilePdf
                    color="#a10505"
                    style={{ width: "20px", height: "30px" }}
                    onClick={() => getDocumentByFileStoreId(structuralCertificate, setIsPreviewLoading)}
                  />
                </td>
                <td>{reviewChecklist1?.structuralSafetyCert?.verifiedByOfficer}</td>
                <td>{reviewChecklist1?.structuralSafetyCert?.correction}</td>
                <td>{reviewChecklist1?.structuralSafetyCert?.remarks}</td>
              </tr>
            )}

            <tr>
              <td>
                Fire Department Certificate<span className="compulsoryField"> *</span>
              </td>
              <td>
                <FaFilePdf
                  color="#a10505"
                  style={{ width: "20px", height: "30px" }}
                  onClick={() => getDocumentByFileStoreId(fireDepartmentCertificate, setIsPreviewLoading)}
                />
              </td>
              <td>{reviewChecklist1?.fireDepartmentCert?.verifiedByOfficer}</td>
              <td>{reviewChecklist1?.fireDepartmentCert?.correction}</td>
              <td>{reviewChecklist1?.fireDepartmentCert?.remarks}</td>
            </tr>

            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>{t("LABEL_PARKING_ARRANGEMENT")}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Total Parking Required (sq.m)<span className="compulsoryField"> *</span>
              </td>
              <td>{firstCheckList?.totalParkingRequired || ""}</td>
              <td>{reviewChecklist1?.totalParkingRequired?.verifiedByOfficer}</td>
              <td>{reviewChecklist1?.totalParkingRequired?.correction}</td>
              <td>{reviewChecklist1?.totalParkingRequired?.remarks}</td>
            </tr>

            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>Parking Provision as per Proposed Plan</strong>
              </td>
            </tr>

            <tr>
              <td rowSpan={2}>
                In Basement<span className="compulsoryField"> *</span>
              </td>
              <td>No. of Cars: {firstCheckList?.parkingProvision?.inBasement?.cars || ""}</td>
              <td>{reviewChecklist1?.parkingProvision?.inBasement?.cars?.verifiedByOfficer}</td>
              <td>{reviewChecklist1?.parkingProvision?.inBasement?.cars?.correction}</td>
              <td>{reviewChecklist1?.parkingProvision?.inBasement?.cars?.remarks}</td>
            </tr>
            <tr>
              <td>No. of ECS: {firstCheckList?.parkingProvision?.inBasement?.ecs || ""}</td>
              <td>{reviewChecklist1?.parkingProvision?.inBasement?.ecs?.verifiedByOfficer}</td>
              <td>{reviewChecklist1?.parkingProvision?.inBasement?.ecs?.correction}</td>
              <td>{reviewChecklist1?.parkingProvision?.inBasement?.ecs?.remarks}</td>
            </tr>

            <tr>
              <td rowSpan={2}>
                In Open Area<span className="compulsoryField"> *</span>
              </td>
              <td>No. of Cars: {firstCheckList?.parkingProvision?.openArea?.cars || ""}</td>
              <td>{reviewChecklist1?.parkingProvision?.openArea?.cars?.verifiedByOfficer}</td>
              <td>{reviewChecklist1?.parkingProvision?.openArea?.cars?.correction}</td>
              <td>{reviewChecklist1?.parkingProvision?.openArea?.cars?.remarks}</td>
            </tr>
            <tr>
              <td>No. of ECS: {firstCheckList?.parkingProvision?.openArea?.ecs || ""}</td>
              <td>{reviewChecklist1?.parkingProvision?.openArea?.ecs?.verifiedByOfficer}</td>
              <td>{reviewChecklist1?.parkingProvision?.openArea?.ecs?.correction}</td>
              <td>{reviewChecklist1?.parkingProvision?.openArea?.ecs?.remarks}</td>
            </tr>

            <tr>
              <td rowSpan={2}>
                In Stilt Area<span className="compulsoryField"> *</span>
              </td>
              <td>No. of Cars: {firstCheckList?.parkingProvision?.inStiltArea?.cars || ""}</td>
              <td>{reviewChecklist1?.parkingProvision?.inStiltArea?.cars?.verifiedByOfficer}</td>
              <td>{reviewChecklist1?.parkingProvision?.inStiltArea?.cars?.correction}</td>
              <td>{reviewChecklist1?.parkingProvision?.inStiltArea?.cars?.remarks}</td>
            </tr>
            <tr>
              <td>No. of ECS: {firstCheckList?.parkingProvision?.inStiltArea?.ecs || ""}</td>
              <td>{reviewChecklist1?.parkingProvision?.inStiltArea?.ecs?.verifiedByOfficer}</td>
              <td>{reviewChecklist1?.parkingProvision?.inStiltArea?.ecs?.correction}</td>
              <td>{reviewChecklist1?.parkingProvision?.inStiltArea?.ecs?.remarks}</td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div
        className="formContainer"
        style={{ marginTop: "18px" }}
        onBlur={(e) => {
          handleInputChange(e.target.name, e.target.value);
        }}
      >
        {/* <div className="formHeaderContainer">
          <h2 className="formHeading">Checklist 2</h2>
        </div> */}
        <Table bordered className="m-0">
          <thead className="table-header">
            <tr>
              <th style={{ width: "50%" }}>Field Name</th>
              <th style={{ minWidth: "fit-content" }}>User Input</th>
              <th style={{ minWidth: "fit-content" }}>Officer Verification</th>
              <th style={{ minWidth: "fit-content" }}>Correction</th>
              <th style={{ minWidth: "fit-content" }}>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {/* Sewerage Section */}
            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>Sewerage (including stormwater)</strong>
              </td>
            </tr>
            <tr>
              <td>
                Public sewerage plan or septic tank<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.publicSewerageOrSepticTank ? "Yes" : "No"}</td>
              <td>{reviewChecklist2?.sewerage?.publicSewerageOrSepticTank?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.sewerage?.publicSewerageOrSepticTank?.correction}</td>
              <td>{reviewChecklist2?.sewerage?.publicSewerageOrSepticTank?.remarks}</td>
            </tr>
            <tr>
              <td>
                Proposed drainage plan approval<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.drainagePlanApproval ? "Yes" : "No"}</td>
              <td>{reviewChecklist2?.sewerage?.drainagePlanApproval?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.sewerage?.drainagePlanApproval?.correction}</td>
              <td>{reviewChecklist2?.sewerage?.drainagePlanApproval?.remarks}</td>
            </tr>

            {/* Road Connectivity Section */}
            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>Road Connectivity</strong>
              </td>
            </tr>
            <tr>
              <td>
                Existing road width in meters<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.existingRoadWidth || ""}</td>
              <td>{reviewChecklist2?.roadConnectivity?.existingRoadWidth?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.roadConnectivity?.existingRoadWidth?.correction}</td>
              <td>{reviewChecklist2?.roadConnectivity?.existingRoadWidth?.remarks}</td>
            </tr>
            <tr>
              <td>
                Minimum 24 meters wide<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.minimum24MetersWide ? "Yes" : "No"}</td>
              <td>{reviewChecklist2?.roadConnectivity?.minimum24MetersWide?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.roadConnectivity?.minimum24MetersWide?.correction}</td>
              <td>{reviewChecklist2?.roadConnectivity?.minimum24MetersWide?.remarks}</td>
            </tr>

            {/* Continue with other sections in a similar pattern... */}

            {/* Water Supply Section */}
            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>Water Supply</strong>
              </td>
            </tr>
            <tr>
              <td>
                Water supply arrangement (capacity in liters per day)<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.waterSupplyArrangement || ""}</td>
              <td>{reviewChecklist2?.waterSupply?.waterSupplyArrangement?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.waterSupply?.waterSupplyArrangement?.correction}</td>
              <td>{reviewChecklist2?.waterSupply?.waterSupplyArrangement?.remarks}</td>
            </tr>
            <tr>
              <td>
                Water supply plan as per requirements<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.waterSupplyPlanApproval ? "Yes" : "No"}</td>
              <td>{reviewChecklist2?.waterSupply?.waterSupplyPlanApproval?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.waterSupply?.waterSupplyPlanApproval?.correction}</td>
              <td>{reviewChecklist2?.waterSupply?.waterSupplyPlanApproval?.remarks}</td>
            </tr>

            {/* Sewerage Disposal Section */}
            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>Sewerage Disposal</strong>
              </td>
            </tr>
            <tr>
              <td>
                STP/Septic tank arrangement made by applicant. Or Establish Connectivity with Govt. Authority
                <span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.stpSepticTankArrangement || ""}</td>
              <td>{reviewChecklist2?.sewerageDisposal?.stpSepticTankArrangement?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.sewerageDisposal?.stpSepticTankArrangement?.correction}</td>
              <td>{reviewChecklist2?.sewerageDisposal?.stpSepticTankArrangement?.remarks}</td>
            </tr>
            <tr>
              <td>
                Yes / No, confirms to standards / not. It is proposed to establish connectivity with the Government Authority.
                <span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.connectivityWithGovernmentAuthority ? "Yes" : "No"}</td>
              <td>{reviewChecklist2?.sewerageDisposal?.connectivityWithGovernmentAuthority?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.sewerageDisposal?.connectivityWithGovernmentAuthority?.correction}</td>
              <td>{reviewChecklist2?.sewerageDisposal?.connectivityWithGovernmentAuthority?.remarks}</td>
            </tr>

            {/* Drainage System Compliance Section */}
            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>Drainage System Compliance</strong>
              </td>
            </tr>
            <tr>
              <td>
                The proposed system is as per the standards or the government agency has approved connectivity.
                <span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.drainageSystemCompliance?.systemAsPerStandards || ""}</td>
              <td>{reviewChecklist2?.drainageSystemCompliance?.systemAsPerStandards?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.drainageSystemCompliance?.systemAsPerStandards?.correction}</td>
              <td>{reviewChecklist2?.drainageSystemCompliance?.systemAsPerStandards?.remarks}</td>
            </tr>
            <tr>
              <td>
                As per standards / not.<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.drainageAsPerStandards ? "Yes" : "No"}</td>
              <td>{reviewChecklist2?.drainageSystemCompliance?.drainageAsPerStandards?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.drainageSystemCompliance?.drainageAsPerStandards?.correction}</td>
              <td>{reviewChecklist2?.drainageSystemCompliance?.drainageAsPerStandards?.remarks}</td>
            </tr>

            {/* Power Supply Section */}
            {/* Power Supply Section */}
            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>Power Supply</strong>
              </td>
            </tr>
            <tr>
              <td>
                Total estimated power demand (kW/MW)<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.totalEstimatedPowerDemand || ""}</td>
              <td>{reviewChecklist2?.powerSupply?.totalEstimatedPowerDemand?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.powerSupply?.totalEstimatedPowerDemand?.correction}</td>
              <td>{reviewChecklist2?.powerSupply?.totalEstimatedPowerDemand?.remarks}</td>
            </tr>
            <tr>
              <td>
                Corporation Ltd. has consent for supply in respect of proposed Garg. Power received<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.powerSupplyConsent ? "Yes" : "No"}</td>
              <td>{reviewChecklist2?.powerSupply?.powerSupplyConsent?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.powerSupply?.powerSupplyConsent?.correction}</td>
              <td>{reviewChecklist2?.powerSupply?.powerSupplyConsent?.remarks}</td>
            </tr>

            {/* Roof-top Rainwater Harvesting System Section */}
            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>Roof-top Rainwater Harvesting System</strong>
              </td>
            </tr>
            <tr>
              <td>
                Total area of rooftop (sq. meters) and provision of drain pipe and recharge pit<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.rooftopArea || ""}</td>
              <td>{reviewChecklist2?.rooftopRainwaterHarvesting?.areaAndDrainage?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.rooftopRainwaterHarvesting?.areaAndDrainage?.correction}</td>
              <td>{reviewChecklist2?.rooftopRainwaterHarvesting?.areaAndDrainage?.remarks}</td>
            </tr>
            <tr>
              <td>
                Found to be as per standard / not<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.drainageStandardsCompliance ? "Yes" : "No"}</td>
              <td>{reviewChecklist2?.rooftopRainwaterHarvesting?.drainageStandardsCompliance?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.rooftopRainwaterHarvesting?.drainageStandardsCompliance?.correction}</td>
              <td>{reviewChecklist2?.rooftopRainwaterHarvesting?.drainageStandardsCompliance?.remarks}</td>
            </tr>

            {/* Solar Water System Section */}
            <tr>
              <td colSpan={5} className="table-subheader">
                <strong>Solar Water System</strong>
              </td>
            </tr>
            <tr>
              <td>
                Provision of pipes in the building design for solar water heating system and determination of suitable location for the plant on the
                rooftop.<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.solarWaterHeatingProvision ? "Yes" : "No"}</td>
              <td>{reviewChecklist2?.solarWaterSystem?.provisionForPipes?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.solarWaterSystem?.provisionForPipes?.correction}</td>
              <td>{reviewChecklist2?.solarWaterSystem?.provisionForPipes?.remarks}</td>
            </tr>
            <tr>
              <td>
                Whether provision made as per building bye-laws or not<span className="compulsoryField"> *</span>
              </td>
              <td className="table-input">{secondCheckList?.buildingByeLawsCompliance ? "Yes" : "No"}</td>
              <td>{reviewChecklist2?.solarWaterSystem?.buildingByeLawsCompliance?.verifiedByOfficer}</td>
              <td>{reviewChecklist2?.solarWaterSystem?.buildingByeLawsCompliance?.correction}</td>
              <td>{reviewChecklist2?.solarWaterSystem?.buildingByeLawsCompliance?.remarks}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ChecklistFarCitizen;
